import store from './store'

class Realtime {
    constructor(server, accountID) {
        this.socket = false
        this.server = server
        this.accountID = accountID
    }

    connect() {
        var loc = window.location;
        var uri = 'ws:';

        if (loc.protocol === 'https:') {
            uri = 'wss:';
        }
        uri += '//' + loc.host;
        uri += loc.pathname + 'ws';

        // get the account ID so we can listen to the real good stuff
        // account_id = localStorage.getItem("AccountID");
        // "ws://localhost:3000/ws?account=" + account_id
        this.socket = new WebSocket(`${this.server}?account=${this.accountID}`)

        this.socket.onopen = this.onOpen
        this.socket.onmessage = this.onMessage
    }

    onMessage(event) {
        console.log("WS event", event);
        const data = JSON.parse(event.data)
        const _monitor = data.data

        if(data.table) {
            switch(data.table) {
                case "monitors":
                    switch(data.action) {
                        // update a monitor
                        case "UPDATE":
                        store.commit("UPDATE_MONITOR", _monitor)
                        console.log(data);
                        break;
                    }
                break;
            }
        } else {
            setTimeout(() => {
                store.commit("SET_DOM_VIEWER_REQUEST", data)
            }, 2000)
        }
    }

    onOpen() {
        console.log('Connected')
    }
}

export default Realtime

// 9.50 + 5.00 - 8.00
// ws.send('Hello, Server!');




// WEBPACK FOOTER //
// ./src/realtime.js